<template>
  <ion-page>
    <master-layout pageTitle="فاکتورهای فروش ضایعات">
      <ion-card>
        <ion-card-content>
          <router-link to="/WastageSellInvoice/Add" >
            <ion-button color="success">
              افزودن
            </ion-button>
          </router-link>
          <DataTable :headers="headers" route="WastageSellInvoice/listAjax"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:[
        'تاریخ ثبت',
        'جمع',
        'امکانات'
      ]
    };
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>